<template>
  <div class="footer">
    <img
      alt="KLINICOS"
      class="img-k"
      src="/klinicos_blanco.png"
    />
  </div>
</template>

<style scoped>
.footer {
  width: 100%;
  background-color: #244125;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
}
.img-k {
  padding-left: 2%;
  padding-top: 10px;
}
.responsive-image {
  width: 25%;
}
@media (max-width: 810px) {
  .responsive-image {
    width: 50%;
  }
}
</style>
